import { Upload, WithMongooseProps } from '@runelab/odin-common'
import { ChatResponseModeEnum, ChatRoleEnum } from 'types/chat'
import { User } from 'types/user'

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  FILE = 'FILE',
  OTHER = 'OTHER',
}

export enum FeedbackEnum {
  GOOD = 'good',
  BAD = 'bad',
}

export enum MessageSourceEnum {
  localBotResponse = 'localBotResponse', // local response such as (welcome message, bot typing, etc)
  remote = 'remote', // remote response such as (operator response, bot response)
  user = 'user', // user questions
}

type OdinChatMessage = WithMongooseProps<{
  senderId: string
  sender?: User
  chatId: string
  timestamp: number
  feedback?: FeedbackEnum
  isSourceAdded?: boolean
  message: string
  type: MessageTypeEnum
  chatResponseMode: ChatResponseModeEnum
  chatSenderEmail?: string
  attachmentIds?: string[]
  attachment?: Upload[]
  chatSenderRole: ChatRoleEnum
}>

export type ChatMessage = OdinChatMessage & {
  isWelcomeMessage?: boolean
  messageSource?: MessageSourceEnum
}
